export const selectCart = state => state.cart.cart;
export const selectTotalQunaity = state => state.cart.cart.totalQuantity;
export const selectIsRefreshing = state => state.cart.isRefreshing;
// export const selectTotalAmount = state => state.cart.totalAmount;
